import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// ----------------------------------------------------------------------

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // The dashboard shell scrolls its content area internally, not the window.
    document.getElementById('dashboard-scroll')?.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
